import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['ownerTypeTab']

  connect() {
    // Initialize the form when the controller connects
    const ownerTypeField = document.getElementById('owner_type')
    if (ownerTypeField) {
      this.updateTabStyles(ownerTypeField.value || 'individual')
    }
  }

  switchOwnerType(event) {
    const ownerType = event.currentTarget.dataset.ownerType

    // Update the hidden field value if it exists
    const ownerTypeField = document.getElementById('owner_type')
    if (ownerTypeField) {
      ownerTypeField.value = ownerType
    }

    // Update the UI
    this.updateTabStyles(ownerType)
  }

  updateTabStyles(ownerType) {
    // Update active tab styling if targets exist
    if (this.hasOwnerTypeTabTarget) {
      this.ownerTypeTabTargets.forEach(tab => {
        if (tab.dataset.ownerType === ownerType) {
          tab.classList.add('bg-primary-800', 'text-white')
          tab.classList.remove(
            'bg-white',
            'text-neutral-700',
            'hover:bg-neutral-50',
          )
        } else {
          tab.classList.remove('bg-primary-800', 'text-white')
          tab.classList.add(
            'bg-white',
            'text-neutral-700',
            'hover:bg-neutral-50',
          )
        }
      })
    }
  }
}
